import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { Quest } from "@quest_editor/mocks";
import { formatDateTime } from "utils/common/formatUtils";

const QuestInfoSection = ({ quest }: { quest: Quest }) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("quest_start_review.section.quest_info")}
      rows={[
        {
          label: t("quest_start_review.field.quest_info.name"),
          children: <Typography color="primary">{quest.name}</Typography>,
        },
        {
          label: t("quest_start_review.field.quest_info.description"),
          children: (
            <Typography color="primary" sx={{ whiteSpace: "pre-wrap" }}>
              {quest.description}
            </Typography>
          ),
        },
        {
          label: t("quest_start_review.field.quest_info.label"),
          children: (
            <Typography color="primary">{quest.note ?? ""}</Typography>
          ),
        },
        {
          label: t("quest_start_review.field.quest_info.reward"),
          children: <Typography color="primary">{quest.reward}</Typography>,
        },
        {
          label: t("quest_start_review.field.quest_info.image"),
          children: quest.imageUrl ? (
            <Box
              component="img"
              src={quest.imageUrl}
              alt={quest.name}
              sx={{ maxWidth: 200, maxHeight: 200 }}
            />
          ) : (
            <Box
              sx={{
                width: 100,
                height: 100,
                bgcolor: "grey.200",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography variant="caption" color="text.secondary">
                {t("common.label.no_image")}
              </Typography>
            </Box>
          ),
        },
        {
          label: t("quest_start_review.field.quest_info.period"),
          children: (
            <Typography color="primary">
              {t("quest_start_review.field.quest_info.period_label", {
                start_at: formatDateTime(quest.startAt),
                end_at: formatDateTime(quest.endAt),
              })}
            </Typography>
          ),
        },
      ]}
    />
  );
};

export default QuestInfoSection;
